import styled from 'styled-components';
import { spacing, body2, colors, Caption as CaptionUi } from 'ui/theme';
import { Tag } from 'ui/tags';
import { Tooltip } from 'ui/tooltip';

const Wrapper = styled.div`
  align-items: center;
  display: inline-flex;
`;

const CaptionText = styled(CaptionUi)`
  color: ${colors.textSecondary};
  margin-left: ${(props) => props.theme.spacing.utils.pxToRem(8)};
  margin-top: ${(props) => props.theme.spacing.utils.pxToRem(3)};
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing.half} ${spacing.plusHalf};
  ${body2}

  /* offset row if grouped with collapsible rows */
  [data-expands='true'] ~ & {
    padding-left: ${spacing.x4};
  }
`;

type Props = {
  label: string;
  value: number;
  tag?: string;
  tooltip?: string;
  caption?: string;
};

export const MetricRow = ({ label, value, tag, tooltip, caption }: Props) => (
  <Row>
    <Wrapper>
      <Tooltip isEnabled={!!tooltip} isUnderlined tooltipContent={tooltip}>
        <span>{label}</span>
      </Tooltip>
      {tag && <Tag>{tag}</Tag>}
      {caption && <CaptionText>{caption}</CaptionText>}
    </Wrapper>
    <span>{value.toLocaleString()}</span>
  </Row>
);
